import { useStatistics } from './StatiscticsContext';
import ColorDistributionBar from '../V3/Statistics/_components/ColorDistributionBar';
import { getColor, getPercent } from '../V3/Statistics/_utils';

import { cn } from '@/utils/tailwind';

import { autoComma } from '@/utils/parser';
import { SalesMarket } from '@/types/statistics';

const MarketChartSection = () => {
  const { activedMonthlySales, salesMarketList, isRegisteredMarket, totalSalesAmount } =
    useStatistics();

  const showOverlay = !isRegisteredMarket || totalSalesAmount === 0;
  const displayList = showOverlay ? MOCK_SALES_MARKET_LIST : salesMarketList;
  const totalAmount = showOverlay
    ? MOCK_SALES_MARKET_LIST.reduce((sum, cur) => sum + cur.SalesAmount, 0)
    : activedMonthlySales.SalesAmount;

  return (
    <div className="flex h-[268px] flex-col gap-4  rounded-[16px] bg-white p-[16px]">
      <div className="text-gr-900 Body1S16">마켓별 매출</div>
      <ColorDistributionBar
        PcVersion
        salesItemList={displayList}
        activedMonthlySalesAmount={totalAmount}
      />
      <div className="scrollbar flex flex-1 flex-col gap-[20px] overflow-y-auto pb-[20px]">
        {displayList.map((item, index) => {
          const percent = getPercent(item.SalesAmount, totalAmount);
          const { background, border } = getColor(index);

          return (
            <div
              key={`${item.MarketName} ${item.SalesAmount} ${index}`}
              className="flex items-center justify-between"
            >
              <div className="flex items-center gap-[10px]">
                <div
                  className={cn('h-[10px] w-[10px] rounded-[5px] border-[1px]', background, border)}
                />
                <img
                  src={item.MarketIconUrl}
                  alt="마켓 아이콘"
                  className="h-[26px] w-[26px] rounded-[13px] border-[1px] border-gr-100"
                  width={26}
                  height={26}
                />
                <span className="text-gr-800 Body5M14">{item.MarketName}</span>
              </div>
              <span className="text-gr-800 Body5M14">{`${autoComma(
                item.SalesAmount,
              )}원 (${percent}%)`}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MarketChartSection;

const MOCK_SALES_MARKET_LIST = [
  {
    MarketIconUrl:
      'https://cplat-images.s3.ap-northeast-2.amazonaws.com/sellerbox/market-icon/IconMarketGmarket.png',
    MarketName: 'G마켓',
    SalesAmount: 24008500,
    SalesCount: 12,
  },
  {
    MarketIconUrl:
      'https://cplat-images.s3.ap-northeast-2.amazonaws.com/sellerbox/market-icon/IconMarketSmartstore.png',
    MarketName: '스마트스토어',
    SalesAmount: 15889010,
    SalesCount: 55,
  },
  {
    MarketIconUrl:
      'https://cplat-images.s3.ap-northeast-2.amazonaws.com/sellerbox/market-icon/IconMarket11st.png',
    MarketName: '11번가',
    SalesAmount: 15714450,
    SalesCount: 12,
  },
  {
    MarketIconUrl:
      'https://cplat-images.s3.ap-northeast-2.amazonaws.com/sellerbox/market-icon/IconMarketAuction.png',
    MarketName: '옥션',
    SalesAmount: 13142770,
    SalesCount: 6,
  },
  {
    MarketIconUrl:
      'https://cplat-images.s3.ap-northeast-2.amazonaws.com/sellerbox/market-icon/IconMarketCoupang.png',
    MarketName: '쿠팡',
    SalesAmount: 7298100,
    SalesCount: 63,
  },
];
